import { Paragraph } from '@hungryroot/ui-kit';
import styles from './CaptchaDisclosure.module.css';

export const CaptchaDisclosure = () => {
  return (
    <Paragraph variant="caption">
      This site is protected by reCAPTCHA and the Google{' '}
      <a
        className={styles['recaptcha-link']}
        target="_BLANK"
        href="https://policies.google.com/privacy"
      >
        Privacy Policy
      </a>{' '}
      and{' '}
      <a
        className={styles['recaptcha-link']}
        target="_BLANK"
        href="https://policies.google.com/terms"
      >
        Terms of Service
      </a>{' '}
      apply.
    </Paragraph>
  );
};
